import React from "react";

/**
 * One of the canvas's two control corners: the top-right holds the 圖層
 * control, the top-left (`side="left"`) the zoom pill. The rail itself lets
 * wheel and drag gestures through to the canvas; each control takes its own
 * pointer events.
 */
const CanvasRail = ({ side = "right", children }) => (
  <div
    data-testid={side === "left" ? "canvas-rail-left" : "canvas-rail"}
    style={{
      position: "absolute",
      top: 8,
      [side]: 8,
      display: "flex",
      flexDirection: "column",
      alignItems: side === "left" ? "flex-start" : "flex-end",
      gap: 6,
      pointerEvents: "none",
      zIndex: 2,
    }}
  >
    {children}
  </div>
);

export default CanvasRail;
